module.exports = __webpack_public_path__ + "images/6a70f3ec.jpg";